<template>
    <div class="table-responsive">
         <!-- Table Search -->
         <div class="resolve-btn">
            <button @click="resolveAllInv()" class="btn btn-danger rounded " title="Resolve All">RESOLVE ALL</button>
        </div>
        <div class="input-group col-md-2 tab-sch tbl-sch rounded">
            <input v-on:keyup.enter="searchInventory" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
            <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
            <span @click="searchInventory()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
        </div>
        

        <!-- Table Search -->
        <table class="table align-items-center table-flush table-hover bidtbl imstbl">
            <thead class="thead-light psticky">
            <tr>
                <th 
                    scope="col" 
                    class="sort"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'account'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'account'  ? 'sort-desc' : '']"  
                    @click="sort('account')" >ACCOUNT</th>
                <th 
                    scope="col" 
                    class="sort"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                    @click="sort('cusip')" >CUSIP</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                    @click="sort('boughtDate')" >BOUGHT DATE</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                    @click="sort('maturityDate')" >MATURITY DATE</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ratingSP'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ratingSP'  ? 'sort-desc' : '']"  
                    @click="sort('ratingSP')" >RATING S&P</th> 
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ratingMoody'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ratingMoody'  ? 'sort-desc' : '']"  
                    @click="sort('ratingMoody')" >RATING MOODY's</th>             
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                    @click="sort('cost')" >COST</th>
                <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                    @click="sort('quantity')" >QTY</th> 
                 <th 
                    scope="col" 
                    class="sort text-center"
                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'isMargin'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'isMargin'  ? 'sort-desc' : '']"  
                    @click="sort('isMargin')" >IS MARGIN</th>                  
                <th 
                    scope="col" 
                    class="text-center">Action</th>
            </tr>
            </thead>
            <tbody class="list no-cursor">
            <tr v-if="totalRows == 0 && !loading">
                <td><p class="nodata">No data available</p>
                </td>
            </tr>
            <tr v-for="inventory in inventoryList" :key="inventory.id" >
                <td>
                    <span v-if="inventory.errorType == 'NOACCOUNTMAP'" style="color:red">
                        <i data-toggle="tooltip" v-bind:title="invNoAccountWarningMessage" class="fas fa-exclamation-triangle" style="cursor:pointer;font-size:12px;color:red"></i>
                        {{inventory.account}}</span>
                    <span v-if="inventory.errorType != 'NOACCOUNTMAP'">{{inventory.account}}</span>
                </td>
                <td>{{inventory.cusip}}</td>
                <td class="text-center">{{moment(inventory.boughtDate).format("MM/DD/YYYY")}}</td>
                <td class="text-center">{{moment(inventory.maturityDate).format("MM/DD/YYYY")}}</td>
                <td class="text-center">{{inventory.ratingSP}}</td>
                <td class="text-center">{{inventory.ratingMoody}}</td>
                <td class="text-center">{{inventory.cost | currency}}</td>
                <td class="text-center">{{inventory.quantity}}</td>
                <td class="text-center">{{inventory.isMargin}}</td>

                <td class="text-center">
                    <div class="d-inline-flex"> 
                        <a  @click="openEditErrorInvModal(inventory)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                        <a  @click="deleteInv(inventory)" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt"></i></a>               
                        <button @click="resolveInv(inventory)" class="btn btn-outline-danger" title="Resolve">RESOLVE</button>
                    </div>    
                </td>
            </tr>
            </tbody>
        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

        </table>
        <!-- Pagination-->
        <b-pagination
            class="mt-4"
            :total-rows="totalRows"
            v-model="currentPage"
            :per-page="perPage"
            @input="getInventoryList(currentPage)"
        ></b-pagination>
        <div class="total-records">
            <span>Total Records : {{totalRows}}</span>
        </div>
        <addNewInventory v-if="addInvModalOpen" v-bind:selectedInventory="selectedInventory"  v-bind:mode="'EDIT'" @close="closeAddInvModal()" />
        <updateErrorInv v-if="editErrorInventoryOpen" v-bind:inventoryData="errorInvData"  @close="closeErroInvModal()" />
    </div>    
</template>
<script>

import config from "@/config";
import authService from "@/authService";
import addNewInventory from "./ImsAddInventoryModal";
import updateErrorInv from "./ImsInventoryErrorEditModal"
export default {
  name: "imsinventoryListError",
  components :{
      addNewInventory,
      updateErrorInv
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "account",
        sortOrder: "ASC",
        inventoryList : [],
        addInvModalOpen : false,
        selectedInventory : {},
        invNoAccountWarningMessage : "PLEASE ADD THIS ACCOUNT TO CUSTOMER TO RESOLVE",
        editErrorInventoryOpen : false,
        errorInvData : null
    };
  },
  methods: { 
    openEditErrorInvModal(data){
        this.errorInvData = data
        this.editErrorInventoryOpen = true;

    },  
    closeErroInvModal(){
        this.editErrorInventoryOpen = false;
        this.getInventoryList(); 

    },
    searchInventory(){
        this.getInventoryList(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getInventoryList(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getInventoryList();
    },

    getInventoryList(){
        this.loading = true;
        
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/inventory/waiting-list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(element => {
            if(element.isMargin === null || element.isMargin === ""){
               element.isMargin = "N/A";
            }else{
              element.isMargin ? element.isMargin = "YES" : element.isMargin = "NO"
            }
           });
          this.inventoryList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    resolveInv(inv){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        inv.isMargin == "YES"  ? inv.isMargin = true : inv.isMargin = false;
        this.$http
        .put(config.baseUrlBidSide + "/inventory/update-waiting-inventory", inv, auth)
        .then((result) => {
            let message = "Inventory "+result.data;
            this.$alert(message,"","success")
            this.getInventoryList();
            this.$root.$emit("invadded");              
        })
        .catch(() => {
                          
        });
        
    },
    resolveAllInv(){
        this.loading = true;

      const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .put(config.baseUrlBidSide + "/inventory/refresh-waiting-inventory",{cognitoSub:authService.getUser().cognitoSub},auth)
        .then(() => {
            // let message = result.data.ADDED ? result.data.ADDED : 0 + " Inventory Added"
            this.$alert("Resolve is under process...","","success")
            this.getInventoryList();
            this.$root.$emit("invadded");  
            this.loading = false;
        })
        .catch(() => {
            this.loading = false;               
        });
    },
    deleteInv(inv){
        if(this.isUploadInProgress()){
            this.$alert("Holding upload is currently in progress. Please try again once it’s complete.","","info")

        }else{
            var message = "Are you sure you want to delete this holding?";
            this.$confirm(message,"Delete holding","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .put(config.baseUrlBidSide + "/inventory/waiting-delete?inventoryIdList="+inv.waitingId,"",auth)
                .then(() => {
                    this.loading = false;              
                    this.getInventoryList();              
                })
                .catch(() => {
                    this.loading = false;              
                });
            });
        }

    },
   
  },
  mounted() {
    this.getInventoryList();
    //  this.$root.$on("searchInventoryError", (data) => {
    //     console.log("on Error",data.searchValue);
    //     this.searchValue = data.searchValue;
    //     this.getInventoryList(); 
    // });
    this.$root.$on("holdingimported", () => {
        this.getInventoryList(); 
    });
  }
};
</script>